import apiServices from 'config/apiServiceApiGateway'
import type {
  ChatChannelType,
  ChatMessageType,
  ChatParticipantType,
} from 'features/Account/@types/chatChannel'

const { Get } = apiServices

export type GetChatChannelListResponseType = {
  data: ChatChannelType[]
  pagination: {
    previous_cursor: string
    next_cursor: string
    next_page_exist: boolean
    previous_page_exist: boolean
  }
}

export type GetChatChannelListRequestType = {
  params: {
    limit: number
    direction: 'next' | 'prev'
    cursor?: string
    order_id?: string
    phone?: string
    status?: 'open' | 'closed'
  }
}

export const getChatChannelList = ({ params }: GetChatChannelListRequestType) =>
  Get<GetChatChannelListResponseType, true>({
    url: '/messaging/internal/v1/room',
    params,
  })

export type GetChatRoomMessagesResponseType = {
  data: {
    room: {
      participant: Nullable<ChatParticipantType[]>
    }
    messages: Nullable<ChatMessageType[]>
    pagination: {
      previous_cursor: string
      next_cursor: string
      next_page_exist: boolean
      previous_page_exist: boolean
    }
    status: string
  }
}

export type GetChatRoomMessagesRequestType = {
  roomId: string
  params: {
    limit: number
    direction?: 'next' | 'prev'
    cursor?: string
  }
}

export const getChatRoomMessages = ({ roomId, params }: GetChatRoomMessagesRequestType) =>
  Get<GetChatRoomMessagesResponseType, true>({
    url: `/messaging/internal/v1/room/${roomId}/chats`,
    params,
  })
